/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Order
 */
export interface OrderDto {
  /**
   * Order ID.
   */
  orderId: number;
  pairName: string;
  ordType: OrderDto.OrdTypeEnum;
  side: OrderDto.SideEnum;
  /**
   * Exists when ordType == LIMIT or STOP_LIMIT.
   */
  price?: number;
  /**
   * Exists when ordType == STOP_LIMIT.
   */
  stopPrice?: number;
  quantity: number;
  /**
   * Exists when ordType == LIMIT.
   */
  requestedQuantityInQuoteAsset: number;
  filledQty: number;
  /**
   * Average executed price.
   */
  avgPrice?: number;
  /**
   * Executed volume.
   */
  volume: number;
  status: OrderDto.StatusEnum;
  receiveTime: string;
  rejectReason?: string;
  initiator: string;
  timeInForce: OrderDto.TimeInForceEnum;
}
export namespace OrderDto {
  export const OrdTypeEnum = {
    Limit: 'LIMIT',
    Market: 'MARKET',
    StopLimit: 'STOP_LIMIT',
  } as const;
  export type OrdTypeEnum = (typeof OrdTypeEnum)[keyof typeof OrdTypeEnum];
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const StatusEnum = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED',
    Filled: 'FILLED',
    PartiallyFilled: 'PARTIALLY_FILLED',
    PartiallyFilledCanceled: 'PARTIALLY_FILLED_CANCELED',
    Rejected: 'REJECTED',
    WaitingTrigger: 'WAITING_TRIGGER',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const TimeInForceEnum = {
    Gtc: 'GTC',
    Ioc: 'IOC',
    Fok: 'FOK',
  } as const;
  export type TimeInForceEnum = (typeof TimeInForceEnum)[keyof typeof TimeInForceEnum];
}
